<div class="chat-layout">
  <!-- Sidebar -->
  <div class="sidebar" [class.collapsed]="sidebarCollapsed">
    <div class="sidebar-header">
      <button mat-icon-button (click)="toggleSidebar()" class="toggle-btn">
        <mat-icon>{{ sidebarCollapsed ? 'menu' : 'menu_open' }}</mat-icon>
      </button>
      <button mat-raised-button color="primary" (click)="createNewChat()" class="new-chat-btn" *ngIf="!sidebarCollapsed">
        <mat-icon>add</mat-icon>
        Nuevo Chat
      </button>
    </div>
    
    <div class="chat-history" *ngIf="!sidebarCollapsed">
      <div class="history-section">
        <h4>Hoy</h4>
        <div class="chat-item" 
             *ngFor="let chat of todayChats" 
             [class.active]="chat.id === currentChatId"
             (click)="selectChat(chat.id)">
          <div class="chat-preview">
            <span class="chat-title">{{ chat.title }}</span>
            <span class="chat-time">{{ getRelativeTime(chat.lastMessage) }}</span>
          </div>
          <button mat-icon-button (click)="deleteChat(chat.id, $event)" class="delete-btn">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </div>
      
      <div class="history-section" *ngIf="olderChats.length > 0">
        <h4>Anteriores</h4>
        <div class="chat-item" 
             *ngFor="let chat of olderChats" 
             [class.active]="chat.id === currentChatId"
             (click)="selectChat(chat.id)">
          <div class="chat-preview">
            <span class="chat-title">{{ chat.title }}</span>
            <span class="chat-time">{{ getRelativeTime(chat.lastMessage) }}</span>
          </div>
          <button mat-icon-button (click)="deleteChat(chat.id, $event)" class="delete-btn">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Chat Area -->
  <div class="chat-container">
    <div class="chat-header">
    <div class="chat-header-info">
      <div class="bot-avatar">
        <mat-icon class="bot-icon">business</mat-icon>
      </div>
      <div class="bot-info">
        <h3>Asistente de Proveedores</h3>
        <span class="bot-status" [class.online]="!isTyping && !isRecording" [class.typing]="isTyping" [class.listening]="isRecording">
          {{ isRecording ? 'Escuchando...' : (isTyping ? 'Escribiendo...' : 'En línea') }}
        </span>
      </div>
    </div>
    <div class="chat-actions">
      <button mat-icon-button (click)="clearChat()" matTooltip="Limpiar chat">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  </div>

  <div class="messages-container" #messagesContainer>
    <div class="messages-wrapper">
      <div class="quick-suggestions" *ngIf="messages.length <= 1">
        <h4>Sugerencias rápidas:</h4>
        <div class="suggestions-grid">
          <button 
            mat-stroked-button 
            *ngFor="let suggestion of quickSuggestions" 
            (click)="selectSuggestion(suggestion)"
            class="suggestion-btn">
            {{ suggestion }}
          </button>
        </div>
      </div>

      <div class="message-group" *ngFor="let message of messages">
        <div class="message" [class.user-message]="message.isUser" [class.bot-message]="!message.isUser">
          <div class="message-avatar" *ngIf="!message.isUser">
            <mat-icon class="bot-icon">business</mat-icon>
          </div>
          
          <div class="message-content">
            <div class="message-bubble" [class.error]="message.status === 'error'">
              <div [innerHTML]="message.content | markdown"></div>
              <div class="message-meta">
                <span class="message-time">{{ getMessageTime(message.timestamp) }}</span>
                <mat-icon 
                  *ngIf="message.isUser" 
                  class="message-status"
                  [class.sending]="message.status === 'sending'"
                  [class.error]="message.status === 'error'">
                  {{ getMessageStatusIcon(message) }}
                </mat-icon>
              </div>
            </div>
          </div>

          <div class="message-avatar user-avatar" *ngIf="message.isUser">
            <mat-icon>person</mat-icon>
          </div>
        </div>
      </div>

      <div class="message bot-message typing-indicator" *ngIf="isTyping">
        <div class="message-avatar">
          <mat-icon class="bot-icon">business</mat-icon>
        </div>
        <div class="message-content">
          <div class="message-bubble typing">
            <div class="typing-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="message-input-container">
    <div class="input-wrapper">
      <mat-form-field appearance="outline" class="message-input-field">
        <mat-label>Escribe tu mensaje...</mat-label>
        <textarea 
          matInput 
          #messageInput
          [formControl]="messageControl"
          (keydown)="onKeyPress($event)"
          [disabled]="isSending"
          rows="1"
          cdkTextareaAutosize
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="4"
          placeholder="Escribe tu mensaje aquí...">
        </textarea>
        <div class="voice-btn-container">
          <button 
            mat-icon-button 
            matSuffix 
            (click)="toggleVoiceRecording()"
            [class.recording]="isRecording"
            class="voice-btn"
            matTooltip="{{ isRecording ? 'Detener grabación' : 'Grabar mensaje' }}">
            <mat-icon>{{ isRecording ? 'stop' : 'mic' }}</mat-icon>
          </button>
          <div class="listening-waves" *ngIf="isRecording">
            <div class="wave wave-1"></div>
            <div class="wave wave-2"></div>
            <div class="wave wave-3"></div>
          </div>
        </div>
        <mat-error *ngIf="messageControl.hasError('required')">
          El mensaje es requerido
        </mat-error>
        <mat-error *ngIf="messageControl.hasError('maxlength')">
          El mensaje no puede exceder 1000 caracteres
        </mat-error>
      </mat-form-field>
      
      <button 
        mat-raised-button 
        color="primary" 
        (click)="sendMessage()"
        [disabled]="messageControl.invalid || isSending"
        class="send-button"
        matTooltip="Enviar mensaje (Enter)">
        <mat-icon *ngIf="!isSending">send</mat-icon>
        <mat-spinner *ngIf="isSending" diameter="24"></mat-spinner>
      </button>
    </div>
  </div>
  </div>
</div>